export function formatDimensions(
	length: number | undefined,
	width: number | undefined,
	height: number | undefined,
) {
	return [length, width, height].map((item) => item ? Math.floor(item).toString() : '__').join(' x ')
}
